const DEFAULT_MASTERY_COUNT = 3;
const DEFAULT_NOCQC = 1;
const DEFAULT_RADNOM_SUBCATEGORY_ORDER = 1;
const DEFAULT_REQUIRED = 1
const DEFAULT_AT_FIRST = 0;
const DEFAULT_AT_LAST = 0;
const DEFAULT_LOCKOUT = 20;
const DEFAULT_MAXIMUM_ATTEMPT = 2;
const DEFAULT_RANDOMIZE_CATEGORIES = 1;

const REQUIRED = 1;
const NOT_REQUIRED = 2;

export {
    DEFAULT_MASTERY_COUNT,
    DEFAULT_NOCQC,
    DEFAULT_RADNOM_SUBCATEGORY_ORDER,
    DEFAULT_REQUIRED,
    DEFAULT_AT_FIRST,
    DEFAULT_AT_LAST,
    DEFAULT_LOCKOUT,
    DEFAULT_MAXIMUM_ATTEMPT,
    DEFAULT_RANDOMIZE_CATEGORIES,

    REQUIRED,
    NOT_REQUIRED,
};